// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_gk-0";
export var discountCodeInput = "_gk-1";